// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__2ptLV","category":"styles_category__+8+bh"};